/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planpriceonrequest3Inputs */

const en_planpriceonrequest3 = /** @type {(inputs: Planpriceonrequest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price on request`)
};

const de_planpriceonrequest3 = /** @type {(inputs: Planpriceonrequest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis auf Anfrage`)
};

/**
* | output |
* | --- |
* | "Price on request" |
*
* @param {Planpriceonrequest3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const planpriceonrequest3 = /** @type {((inputs?: Planpriceonrequest3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planpriceonrequest3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_planpriceonrequest3(inputs)
	return de_planpriceonrequest3(inputs)
});
export { planpriceonrequest3 as "planPriceOnRequest" }